// This is the entry point for webpack to import the appropriate modules and dependencies.

require('react');
require('react-dom');
require('../../jsx/Root.jsx');